module.exports = __webpack_public_path__ + "img/blue_086.8649c3c3.png";